const SocketEvent = {
  INITIATE_UNIFICATION_EVENT_NAME: 'Data Unification',

  INPUT_SYNC_EVENT_NAME: 'Transaction Source Data Upload',
  MASTER_SYNC_EVENT_NAME: 'Master Source Data Upload',

  START_CALCULATION_EVENT_NAME: 'Payout Calculation',

  NUDGE_EVENT_NAME: 'Nudge Trigger',
  TASK_CREATION_PROGRESS: 'TASK_CREATION_PROGRESS',

  TASK_APPROVAL: 'Auto-Authorized',
  TASK_REMINDER: 'Pending Authorization',
  TASK_ESCALATION: 'Follow-up Notice',

  COMPUTE_CORRECTION_DIFF_EVENT_NAME:
    'Data uploaded for data correction compute difference',
  CLEAN_DATA_DIFF_EVENT_NAME: 'Difference Data delete from diff',
  EXECUTE_CORRECTION_EVENT_NAME: 'Data saved for data correction',
  DATA_CORRECTION_RESET_EVENT_NAME: 'Data reset for data correction',
};

export default SocketEvent;
